import React, { useState, useEffect } from "react";
import { Container, Row, Col, Form, Button } from "react-bootstrap";
import { getPlanosManutencao } from "../../services/api_planos_manutencao";
import { getApplications } from "../../services/api_aplicacoes";
import { getTipoAplicacao } from "../../services/api_tipo_aplicacao";
import Swal from "sweetalert2";

const FiltroAplicacoesPlano = ({ onApplyFilters }) => {
  const [id_aplicacao, setIdAplicacao] = useState("");
  const [id_tipo_aplicacao, setIdTipoAplicacao] = useState("");
  const [id_plano, setIdPlanoManutencao] = useState("");
  const [aplicacoesListagem, setAplicacoesListagem] = useState([]);
  const [aplicacoesFiltradas, setAplicacoesFiltradas] = useState([]);
  const [tiposAplicacaoListagem, setTiposAplicacaoListagem] = useState([]);
  const [planosManutencaoListagem, setPlanosManutencaoListagem] = useState([]);
  const [dataInicial, setDataInicial] = useState("");
  const [dataFinal, setDataFinal] = useState("");

  const handleApplyFilters = () => {
    const filters = {
      idTipoAplicacao: id_tipo_aplicacao,
      idAplicacao: id_aplicacao,
      idPlano: id_plano,
      dataInicial: handleData(dataInicial),
      dataFinal: handleData(dataFinal),
    };
    //console.log("Filtros aplicados: ", filters);
    onApplyFilters(filters);
  };

  const handleData = (data) => {
    if (data) {
      const partes = data.split("-");
      const ano = partes[0];
      const mes = partes[1];
      const dia = partes[2];
      return `${ano}-${mes}-${dia}`;
    }
    return "";
  };

  useEffect(() => {
    const fetchAplicacao = async () => {
      try {
        const response = await getApplications();
        if (response) {
          const aplicacoesAtivas = response.data.Aplicacao.filter(
            (aplicacao) => aplicacao.deleted_at == null
          );
          setAplicacoesListagem(aplicacoesAtivas);
          setAplicacoesFiltradas(aplicacoesAtivas);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    const fetchTipoAplicacao = async () => {
      try {
        const response = await getTipoAplicacao();
        if (response) {
          const tiposAplicacaoAtivos = response.data.TiposAplicacao.filter(
            (tipoAplicacao) => tipoAplicacao.deleted_at == null
          );
          setTiposAplicacaoListagem(tiposAplicacaoAtivos);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    const fetchPlanos = async () => {
      try {
        const response = await getPlanosManutencao();
        if (response) {
          const planosManutencaoAtivos = response.data.PlanosManutencao.filter(
            (planosManutencao) => planosManutencao.deleted_at == null
          );
          setPlanosManutencaoListagem(planosManutencaoAtivos);
        } else {
          console.error("Algo deu errado:");
        }
      } catch (error) {
        console.error("Erro ao obter dados:", error);
      }
    };

    fetchTipoAplicacao();
    fetchAplicacao();
    fetchPlanos();
  }, []);

  useEffect(() => {
    handleAplicacoesListagem(id_tipo_aplicacao);
  }, [id_tipo_aplicacao]);

  const handleAplicacoesListagem = (idTipoAplicacao) => {
    if (idTipoAplicacao === "") {
      setAplicacoesListagem(aplicacoesFiltradas);
      return;
    }

    const aplicacoesTipoSelecionado = aplicacoesFiltradas.filter(
      (aplicacao) =>
        aplicacao.id_tipo_aplicacao.toString() === idTipoAplicacao.toString()
    );

    if (aplicacoesTipoSelecionado.length === 0) {
      Swal.fire({
        icon: "warning",
        title: "Nenhuma aplicação encontrada",
        text: "Não existe nenhuma aplicação do tipo escolhido.",
      });
    }
    setAplicacoesListagem(aplicacoesTipoSelecionado);
  };

  return (
    
    <Container>
      <Row className="mb-3">
        <Col md={4} className="mb-3">
          <Form.Group controlId="formTipoAplicacao">
            <Form.Label>Tipo de Aplicação</Form.Label>
            <Form.Control
              as="select"
              value={id_tipo_aplicacao}
              onChange={(e) => setIdTipoAplicacao(e.target.value)}
            >
              <option value="">Selecione</option>
              {tiposAplicacaoListagem &&
                tiposAplicacaoListagem.map((tipoAplicacao) => (
                  <option key={tipoAplicacao.id} value={tipoAplicacao.id}>
                    {tipoAplicacao.descricao}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={4} className="mb-3">
          <Form.Group controlId="formAplicacao">
            <Form.Label>Aplicação</Form.Label>
            <Form.Control
              as="select"
              value={id_aplicacao}
              onChange={(e) => setIdAplicacao(e.target.value)}
            >
              <option value="">Selecione</option>
              {aplicacoesListagem &&
                aplicacoesListagem.map((aplicacao) => (
                  <option key={aplicacao.id} value={aplicacao.id}>
                    {aplicacao.descricao}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={4} className="mb-3">
          <Form.Group controlId="formPlano">
            <Form.Label>Plano</Form.Label>
            <Form.Control
              as="select"
              value={id_plano}
              onChange={(e) => setIdPlanoManutencao(e.target.value)}
            >
              <option value="">Selecione</option>
              {planosManutencaoListagem &&
                planosManutencaoListagem.map((plano) => (
                  <option key={plano.id} value={plano.id}>
                    {plano.descricao}
                  </option>
                ))}
            </Form.Control>
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="formDataInicial">
            <Form.Label>Data Inicial</Form.Label>
            <Form.Control
              type="date"
              value={dataInicial}
              onChange={(e) => setDataInicial(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4}>
          <Form.Group controlId="formDataFinal">
            <Form.Label>Data Final</Form.Label>
            <Form.Control
              type="date"
              value={dataFinal}
              onChange={(e) => setDataFinal(e.target.value)}
            />
          </Form.Group>
        </Col>
        <Col md={4} className="d-flex align-items-end">
          <Button variant="primary" onClick={handleApplyFilters}>
            Aplicar Filtro
          </Button>
        </Col>
      </Row>
    </Container>
  );
};

export default FiltroAplicacoesPlano;
